<template>
  <div class="common-footer">
    <p>
      Copyright <font class="fontfam">&copy;</font> 2000 - {{ currentYear }} www.chinaacc.com All Rights
      Reserved.&#12288;北京东大正保科技有限公司 版权所有<br />
      <a href="//www.chinaacc.com/help/setindex.htm" id="footindexseturl" target="_blank">设为首页</a>－
      <a href="//www.chinaacc.com/wangxiao/jieshao/about.shtml" target="_blank" rel="external nofollow">关于我们</a>－
      <a href="//www.chinaacc.com/wangxiao/jieshao/about_ceo.shtml" target="_blank" rel="external nofollow"
        >董事长风采</a
      >－ <a href="//edu.chinaacc.com/" target="_blank" rel="external nofollow">校企合作</a>－
      <a href="//www.chinaacc.com/wangxiao/jieshao/lianxi.htm" target="_blank" rel="external nofollow">联系我们</a>－
      <a id="jiucuo" href="//www.chinaacc.com/jiucuo/index.shtm" target="_blank" rel="external nofollow">我要纠错</a>－
      <a href="//www.chinaacc.com/jianjie/zhaopin.htm" target="_blank" rel="external nofollow">招聘信息</a>－
      <a href="//www.chinaacc.com/help/" target="_blank" rel="external nofollow">帮助中心</a>－
      <a href="//www.chinaacc.com/map.htm" target="_blank">网站地图</a><br />
      建议邮箱：<a href="mailto:jy@chinaacc.com">jy@chinaacc.com</a> 客服邮箱：<a href="mailto:chinaacc@chinaacc.com"
        >chinaacc@chinaacc.com</a
      >
      投诉电话：010-82330110 咨询电话：010-82318888 / 4008104588 传真：010-82310109 / 82330109<br />
      <a href="//www.chinaacc.com/licence/icp.htm" target="_blank" rel="external nofollow"
        >京ICP证030467号&nbsp;&nbsp;&nbsp;</a
      >
      <a href="//www.chinaacc.com/licence/38.htm" target="_blank" rel="external nofollow"
        >教育部职成司函[2003]38号&nbsp;&nbsp;&nbsp;</a
      >
      <a href="//www.chinaacc.com/licence/478.htm" target="_blank" rel="external nofollow"
        >电信业务审批[2003]字第478号</a
      >/
      <a href="//www.chinaacc.com/licence/573.htm" target="_blank" rel="external nofollow">第573号&nbsp;&nbsp;&nbsp;</a>
      <a href="/licence/cbw.htm" target="_blank" rel="external nofollow">出版物经营许可证 </a>
      <a target="_blank" href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802023314">
        <img
          src="@/assets/images/mockExam/ba-icon.png"
          border="0"
          style="vertical-align: middle; width: 20px; height: 20px;"
          width="20"
          height="20"
        />京公网安备 11010802023314号&nbsp;&nbsp;&nbsp;
      </a>
      <a href="//www.chinaacc.com/licence/kjyyzz.htm" target="_blank" rel="external nofollow">营业执照</a>
    </p>

    <div class="approve">
      <a rel="nofollow" target="_blank" href="//www.hd315.gov.cn/beian/view.asp?bianhao=0102000121400018">
        <img height="48" width="128" border="0" src="//www.chinaacc.com/images/hd315.png" alt="经营性网站备案信息" />
      </a>
      <a rel="nofollow" target="_blank" href="//www.itrust.org.cn/yz/pjwx.asp?wm=1723956603">
        <img
          height="48"
          width="128"
          border="0"
          src="//www.chinaacc.com/images/itrust.png"
          alt="中国信用企业Credit Rating"
        />
      </a>
      <a
        rel="nofollow"
        target="_blank"
        href="https://ss.knet.cn/verifyseal.dll?sn=2010122300100003484&amp;ct=df&amp;pa=624896"
      >
        <img height="48" width="128" border="0" src="//www.chinaacc.com/images/knet.png" alt="可信网站示范单位" />
      </a>
      <a rel="nofollow" target="_blank" href="//si.trustutn.org/info?sn=674160913024134815113&certType=1">
        <img src="//www.chinaacc.com/images/rzlm.png" height="48" width="138" border="0" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentYear: null
    };
  },
  mounted() {
    this.currentYear = new Date().getFullYear();
  }
};
</script>
<style lang="scss" scoped>
.common-footer {
  color: #666;
  font-size: 12px;
  font-family: '\5FAE\8F6F\96C5\9ED1,\9ED1\4F53';
  text-align: center;
  line-height: 26px;

  .fontfam {
    font-family: 'Verdana,Arial,Helvetica,sans-serif';
  }

  .approve {
    text-align: center;
    margin-top: 10px;

    a {
      margin: 0 5px;
    }

    img {
      vertical-align: top;
    }
  }
}
</style>
